import { createI18n } from 'vue-i18n';
import { intlZhCn } from './locale/zh-cn';
import { intlEnUs } from 'core/i18n/locale/intl_en';
import { intlEsEs } from 'core/i18n/locale/intl_es';
import { intlHiIn } from 'core/i18n/locale/intl_hi';
import { intlIdId } from 'core/i18n/locale/intl_id';
import { intlPtBr } from 'core/i18n/locale/intl_pt';
import { intlViVn } from 'core/i18n/locale/intl_vi';

let i18n: any;

async function useI18n(language: string) {
    try {
        const messages = {
            'zh-cn': intlZhCn,
            en: intlEnUs,
            es: intlEsEs,
            hi: intlHiIn,
            id: intlIdId,
            pt: intlPtBr,
            vn: intlViVn,
        };

        // return createI18n({
        //     locale: language || 'zh-cn',
        //     messages,
        //     globalInjection: true,
        //     legacy: false,
        // });
        i18n = createI18n({
            locale: language || 'zh-cn',
            messages,
            globalInjection: true,
            legacy: false,
        });

        return i18n;
    } catch (error) {
        throw new Error(`Language file not found for "${language}"`);
    }
}

// 创造一个t函数 方便使用
export function useT() {
    return i18n.global.t;
}

// locale
export function useLocale() {
    return i18n.global.locale;
}

export default useI18n;
